import Rails from '@rails/ujs'
import $ from 'jquery'

import type { CurrentUser } from '@/javascript/interfaces'

declare global {
	interface Window {
		current_user: CurrentUser
		franchisorSSOPath: string | null
		location: Location
		manageCaregiverGroups: boolean
		showTrainingDashboard: boolean
	}
}

import './lib/global-event-utils'
import '@vuejs/plugins/bugsnag'

import initShowPassword from './components/show_password'
import initWidgetPlugin from './lib/widget'

$(document).ready(function () {
	initShowPassword()
	initWidgetPlugin()

	if (!window._rails_loaded) { Rails.start() }
})
